/**
 * Junip Rating Display
 * Extrae el valor del rating desde aria-label y lo muestra en el contador de reviews
 */

(function() {
  'use strict';

  // Agregar estilos CSS para ocultar el número de reviews y mostrar solo el rating
  function addCustomStyles() {
    if (!document.getElementById('junip-rating-custom-styles')) {
      const style = document.createElement('style');
      style.id = 'junip-rating-custom-styles';
      style.textContent = `
        .junip-product-summary-review-count {
          position: relative;
        }
        .junip-product-summary-review-count .review-count-number {
          display: none !important;
        }
        .junip-product-summary-review-count .review-rating {
          display: inline !important;
        }
      `;
      document.head.appendChild(style);
    }
  }

  function updateJunipRatingDisplay(retryCount = 0) {
    // Máximo número de reintentos
    const maxRetries = 10;
    
    // Buscar el elemento con la clase que contiene el rating en aria-label
    const ratingContainer = document.querySelector('.junip-star-rating-container, .junip-product-summary-star-rating-container, [aria-label*="stars"]');
    
    if (!ratingContainer) {
      // Si no se encuentra y no hemos excedido los reintentos, intentar de nuevo
      if (retryCount < maxRetries) {
        setTimeout(() => updateJunipRatingDisplay(retryCount + 1), 500);
      }
      return;
    }

    // Obtener el valor del aria-label
    const ariaLabel = ratingContainer.getAttribute('aria-label');
    
    if (ariaLabel && ariaLabel.includes('stars')) {
      // Extraer SOLO el número del rating (ej: "4.89 stars, 236 reviews" -> "4.89")
      // Mejorar la regex para capturar solo el rating, no los reviews
      const ratingMatch = ariaLabel.match(/^(\d+\.?\d*)\s*stars?/i);
      
      if (ratingMatch && ratingMatch[1]) {
        const rating = ratingMatch[1];
        
        // Buscar todos los elementos donde queremos mostrar el rating
        const allReviewCountElements = document.querySelectorAll('.junip-product-summary-review-count');
        
        // Si no hay elementos, esperar un poco más
        if (allReviewCountElements.length === 0 && retryCount < maxRetries) {
          setTimeout(() => updateJunipRatingDisplay(retryCount + 1), 500);
          return;
        }
        
        allReviewCountElements.forEach(element => {
          // Obtener el texto actual
          let currentText = element.textContent || '';
          
          // Si el elemento está vacío, esperar un poco para que se cargue
          if (!currentText && retryCount < maxRetries) {
            setTimeout(() => updateJunipRatingDisplay(retryCount + 1), 300);
            return;
          }
          
          // Limpiar el texto: quitar paréntesis y espacios extras
          currentText = currentText.replace(/[()]/g, '').trim();
          
          // Si ya tiene el formato correcto con el rating, no hacer nada
          if (currentText.includes(rating)) {
            return;
          }
          
          // Extraer el número de reviews del texto actual
          const reviewCountMatch = currentText.match(/(\d+)/);
          
          // Agregar un pequeño retraso antes de actualizar el DOM
          setTimeout(() => {
            if (reviewCountMatch) {
              // Crear estructura HTML con el número oculto y el rating visible
              element.innerHTML = `<span class="review-count-number">${reviewCountMatch[1]}</span> <span class="review-rating">(${rating})</span>`;
            } else {
              // Si no hay número, solo mostrar el rating entre paréntesis
              element.innerHTML = `<span class="review-rating">(${rating})</span>`;
            }
          }, 100); // Pequeño retraso de 100ms para asegurar que el elemento esté listo
        });
      }
    }
  }

  // Ejecutar cuando el DOM esté listo con un retraso inicial
  function initializeJunipRating() {
    addCustomStyles();
    // Esperar 1 segundo para asegurar que Junip haya cargado sus elementos
    setTimeout(() => {
      updateJunipRatingDisplay();
    }, 1000);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeJunipRating);
  } else {
    initializeJunipRating();
  }

  // También observar cambios en el DOM por si Junip carga dinámicamente
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'attributes') {
        // Verificar si se agregaron elementos de Junip
        const hasJunipElements = document.querySelector('.junip-star-rating-container, .junip-product-summary-star-rating-container, [aria-label*="stars"]');
        if (hasJunipElements) {
          updateJunipRatingDisplay();
        }
      }
    });
  });

  // Configurar el observer para observar cambios en todo el body
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-label']
  });

})();